"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useProductImageAdornmentsMapper;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends5 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var _ProductImageDecoratedAdornment = _interopRequireDefault(require("@sprinx/react-com/ProductImageDecoratedAdornment"));

var _ProductImageDecoratedAdornmentPercent = _interopRequireDefault(require("@sprinx/react-com/ProductImageDecoratedAdornmentPercent"));

var adornmentMapConfig = {
  cardBig: {
    adornmentAsideLeft: [],
    adornmentAsideRight: [],
    adornmentInsideBottomLeft: [],
    adornmentInsideBottomRight: [],
    adornmentInsideTopLeft: [['gift', null, {
      bgColor: '#9575cd'
    }], 'sale'],
    adornmentInsideTopRight: [['discount', _ProductImageDecoratedAdornmentPercent.default, {
      bgColor: 'red',
      size: 'normal'
    }]]
  },
  card: {
    adornmentAsideLeft: [],
    adornmentAsideRight: [],
    adornmentInsideBottomLeft: [],
    adornmentInsideBottomRight: [],
    adornmentInsideTopLeft: [],
    adornmentInsideTopRight: [] // adornmentInsideTopLeft: [['gift', null, { bgColor: '#9575cd' }], 'sale'],
    // adornmentInsideTopRight: [['discount', ProductImageDecoratedAdornmentPercent, { bgColor: 'red', size: 'normal' }]],

  },
  row: {
    adornmentAsideLeft: [],
    adornmentAsideRight: [],
    adornmentInsideBottomLeft: [],
    adornmentInsideBottomRight: [],
    adornmentInsideTopLeft: [['gift', null, {
      bgColor: '#9575cd'
    }], 'sale'],
    adornmentInsideTopRight: [['discount', _ProductImageDecoratedAdornmentPercent.default, {
      bgColor: 'red',
      size: 'normal'
    }]]
  },
  detail: {
    adornmentAsideLeft: [],
    adornmentAsideRight: [],
    adornmentInsideBottomLeft: [],
    adornmentInsideBottomRight: [],
    adornmentInsideTopLeft: [['gift', null, {
      bgColor: '#9575cd'
    }], 'sale'],
    adornmentInsideTopRight: [['discount', _ProductImageDecoratedAdornmentPercent.default, {
      bgColor: 'red',
      size: 'normal'
    }]]
  }
};

var cond = function cond() {
  for (var _len = arguments.length, cnds = new Array(_len), _key = 0; _key < _len; _key++) {
    cnds[_key] = arguments[_key];
  }

  return function (v) {
    return (cnds.find(function (x) {
      return x[0](v);
    }) || [null, function () {
      return undefined;
    }])[1](v);
  };
};

var tr = function tr(viewMaps) {
  return Object.entries(viewMaps).reduce(function (nextViewMaps, _ref) {
    var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
        view = _ref2[0],
        vmp = _ref2[1];

    return (0, _extends5.default)({}, nextViewMaps, (0, _defineProperty2.default)({}, view, Object.entries(vmp).reduce(function (viewMap, _ref3) {
      var _ref4 = (0, _slicedToArray2.default)(_ref3, 2),
          adornmentPosition = _ref4[0],
          adornments = _ref4[1];

      return (0, _extends5.default)({}, viewMap, adornments.reduce(function (ret, cfg) {
        var _ref5 = Array.isArray(cfg) ? cfg : [cfg],
            _ref6 = (0, _slicedToArray2.default)(_ref5, 3),
            adornmentType = _ref6[0],
            component = _ref6[1],
            props = _ref6[2];

        return (0, _extends5.default)({}, ret, (0, _defineProperty2.default)({}, adornmentType, [adornmentPosition, component || _ProductImageDecoratedAdornment.default, props]));
      }, {}));
    }, {})));
  }, {});
};

var adornmentMap = tr(adornmentMapConfig);
/**
 * @return Tuple `[children, moreProps]`
 */

var resolveMapStrategy = function resolveMapStrategy() {
  return (
    /* product, mapStrategyCfg */
    [null, {}]
  );
};
/**
 *
 * @param {Object} [options]
 * @param {string} [options.adornmentsFieldName = 'adornments'] Name of field
 * @param {*} view
 * @param {*} productAdornments
 */


function useProductImageAdornmentsMapper(options, view, product) {
  var t = (0, _useTranslate.default)();
  return _react.default.useMemo(function () {
    var _ref7 = options || {},
        _ref7$adornmentsField = _ref7.adornmentsFieldName,
        adornmentsFieldName = _ref7$adornmentsField === void 0 ? 'adornments' : _ref7$adornmentsField;

    var viewMap = adornmentMap[view];
    if (!viewMap) return {};
    var productAdornments = product[adornmentsFieldName];
    return (productAdornments || []).reduce(function (r, _ref8) {
      var content = _ref8.content,
          type = _ref8.type;
      var cfg = viewMap[type];
      if (!cfg) return r;

      var _cfg = (0, _slicedToArray2.default)(cfg, 3),
          adornmentPosition = _cfg[0],
          Component = _cfg[1],
          props = _cfg[2]; // content: string | Object | TranslationDictionary | MapStrategy


      var _cond = cond( // simple string content
      [function (c) {
        return typeof c === 'string';
      }, function (c) {
        return [c, {}];
      }], // Translation dictionary
      [function (c) {
        return Array.isArray(c) && typeof c[0] !== 'string';
      }, function (translationDictionary) {
        return [t(translationDictionary), {}];
      }], // MapStrategy
      [function (c) {
        return Array.isArray(c) && typeof c[0] === 'string';
      }, function (mapStrategy) {
        return resolveMapStrategy(product, mapStrategy);
      }], // Object
      [function (c) {
        return c !== null && (0, _typeof2.default)(c) === 'object';
      }, function (c) {
        return [null, c];
      }], // Default
      [function () {
        return true;
      }, function () {
        return [null, {}];
      }])(content),
          _cond2 = (0, _slicedToArray2.default)(_cond, 2),
          children = _cond2[0],
          moreProps = _cond2[1];

      return cfg ? (0, _extends5.default)({}, r, (0, _defineProperty2.default)({}, adornmentPosition, [].concat((0, _toConsumableArray2.default)(r[adornmentPosition] || []), [/*#__PURE__*/_react.default.createElement(Component, (0, _extends5.default)({
        key: "".concat(adornmentPosition).concat(type)
      }, props, moreProps), children)]))) : r;
    }, {});
  }, [options, product, t, view]);
}